import React from 'react'
import { Link } from 'react-router-dom';
const arrow =`https://raw.githubusercontent.com/wdridoy11/web-icon/4ee112a7106239ebb32814ff4f7e7b4331d33a3f/right-arrow.png`;

const Project = (props) => {
  const {id,title,img} = props.project;
  const modalData = props.modalData;
  const handleModal = props.handleModal;
  return (
    <div>
      <div>
        <div className='bg-[#182233] rounded-md' >
          <img className='hover:scale-105 duration-500' src={img} alt="Project" />
          <div className='px-3 pb-5 border-t border-[#2A3343] pt-4'>
              <h3 className="text-2xl mb-2 font-medium rounded-b-lg text-white">{title}</h3>
              <label onClick={()=>handleModal(id)} className='text-[#22d3ee] flex gap-2 cursor-pointer ' htmlFor="my-modal-3">More Details<img className='w-6' src={arrow} alt="" /></label>
          </div>
        </div>
        <div>
            <input type="checkbox" id="my-modal-3" className="modal-toggle" />
            <div className="modal">
              <div className="modal-box w-11/12 max-w-5xl">
                <label htmlFor="my-modal-3" className="btn btn-sm btn-circle absolute right-2 top-2">✕</label>
                <img className='w-full md:w-1/2 mx-auto' src={modalData.img} alt="Project" />
                <h3 className="text-2xl font-bold text-white">{modalData.title}</h3>
                <p className="py-4 text-white">{modalData.description}</p>
                <p className="pb-4 text-white">Using Tools: </p>
                <div className='flex flex-wrap items-center gap-3 mb-5'>
                    {modalData.tools && modalData?.tools.map((tool,index)=><li key={index} className='mb-2 text-white'>{tool}</li>)}
                </div>
                <div className='flex flex-wrap gap-3'>
                    <Link className="bg-transparent inline-block text-white capitalize border-2 border-[#22d3ee] py-2 px-6 rounded-full mt-2 hover:bg-[#22d3ee] hover:text-white duration-500 mr-3" to={`${modalData.link}`} target='_blank'>Live demo</Link>
                    {modalData.client_code && <Link className="bg-transparent inline-block text-white capitalize border-2 border-[#22d3ee] py-2 px-6 rounded-full mt-2 hover:bg-[#22d3ee] hover:text-white duration-500 mr-3" to={`${modalData.client_code}`} target='_blank'>Client Code</Link>}
                    {modalData.server_code && <Link className="bg-transparent inline-block text-white capitalize border-2 border-[#22d3ee] py-2 px-6 rounded-full mt-2 hover:bg-[#22d3ee] hover:text-white duration-500 mr-3" to={`${modalData.server_code}`} target='_blank'>Server Code</Link>}
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  )
}

export default Project